/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { PropTypes } from 'prop-types'
import { useHistory } from 'react-router-dom'
import { Card } from 'primereact/card'
import { useParams } from 'react-router'

import back from '../assets/images/back.svg'

function ViewCompanyComponent({ selectedCompany, getCompanyById }) {
  const { id } = useParams()
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    if (!selectedCompany || (selectedCompany && selectedCompany.companyId !== id)) {
      setIsLoading(true)
      getCompanyById(id)
    }
  }, [getCompanyById, selectedCompany, id])
  useEffect(() => {
    setIsLoading(false)
  }, [selectedCompany])
  const history = useHistory()
  const viewCompany = (companyId) => {
    history.push('/dashboard/view-company/' + companyId)
  }
  const BackClick = () => {
    history.goBack()
  }

  return (
    <div className="p-col-10 dashboard">
      <div className="dashboard--wrapper">
        <Card className="cardBase addSector">
          <p className="title flex m-b-25">
            <img src={back} alt={back} className="m-r-10 pointer" onClick={() => BackClick()} />{selectedCompany?.name ? selectedCompany.name : 'View Company'}
          </p>
          <div className="p-grid titleSec m-0">
            <div className="p-col-4">
              <p>Logo</p>
            </div>
            <div className="p-col-8">
              <p>Sub Brands</p>
            </div>
          </div>
          <div className="p-grid titleSec m-0">
            <div className="p-col-4">
              <div className="viewLogo">
                {(selectedCompany && selectedCompany.encodedImageString) && <img alt="Company Logo" src={`data:image/jpeg;base64,${selectedCompany.encodedImageString}`} style={{ width: '80px' }}></img>}
                {selectedCompany && selectedCompany.logoURL && selectedCompany.logoPath ? <img alt="Company Logo" src={`${selectedCompany.logoPath}`} style={{ width: '80px' }}></img> : ''}
              </div>
            </div>
            <div className="p-col-8">
              <div className="viewBrand">
                {selectedCompany?.subBrandsCompany ? selectedCompany.subBrandsCompany.map(c => {
                  return <button key={c.companyId} onClick={() => viewCompany(c.companyId)}>{c.name}</button>
                }) : 'No sub brands available'}

              </div>
            </div>
          </div>
          <div className="p-grid titleSec m-0">
            <div className="p-col-4">
              <p>Ticker</p>
              <h5>{selectedCompany?.ticker ? selectedCompany.ticker : '--'}</h5>
            </div>
            <div className="p-col-4">
              <p>Market Capitalization</p>
              <h5>{selectedCompany?.marketCapitalization ? selectedCompany.marketCapitalization : '0.0000'}</h5>
            </div>
            <div className="p-col-4">
              <p>Sector</p>
              <h5>{selectedCompany?.sector ? selectedCompany.sector.name : '--'}</h5>
            </div>
            <div className="p-col-4">
              <p>Industry</p>
              <h5>{selectedCompany?.industry ? selectedCompany.industry.name : '--'}</h5>
            </div>
            <div className="p-col-4">
              <p>Exchange</p>
              <h5>{selectedCompany?.exchange ? selectedCompany.exchange.name : '--'}</h5>
            </div>
            <div className="p-col-4">
              <p>Exchange Country</p>
              <h5>{selectedCompany?.exchangeCountry ? selectedCompany.exchangeCountry : '--'}</h5>
            </div>
            <div className="p-col-4">
              <p>Earnings Yield</p>
              <h5>{selectedCompany?.earningsYeild ? selectedCompany.earningsYeild : '--'}</h5>
            </div></div>
        </Card>
        <div>{isLoading && <div>No company found!!!</div>}</div>
      </div>
    </div>
  )
}
ViewCompanyComponent.propTypes = {
  selectedCompany: PropTypes.object,
  getCompanyById: PropTypes.func
}
export default ViewCompanyComponent
